import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-house",
  "use": "icon-house-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-house\"><path fill=\"#BFCBD9\" d=\"M488.704 14.279111L10.382222 433.038222a28.444444 28.444444 0 0 0 18.716445 49.834667h141.198222V967.111111a56.888889 56.888889 0 0 0 56.888889 56.888889h600.519111a56.888889 56.888889 0 0 0 56.888889-56.888889V482.872889h110.165333a28.444444 28.444444 0 0 0 19.370667-49.265778L564.935111 15.445333a56.888889 56.888889 0 0 0-76.231111-1.166222zM827.733333 425.984V967.111111H227.185778V425.984H104.789333l421.376-368.924444 396.288 368.924444H827.733333z\" /><path fill=\"#BFCBD9\" d=\"M392.903111 701.923556l-31.004444-28.359112a28.444444 28.444444 0 0 1 38.4-41.984l29.354666 26.851556 33.336889-39.424a142.222222 142.222222 0 1 1 46.933334 32.625778l-121.400889 143.587555a28.444444 28.444444 0 0 1-43.434667-36.721777l47.815111-56.604445z m172.999111-95.744a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/house.svg
// module id = DUyu
// module chunks = 87